import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import TaxPayerApiKey from "../../models/taxpayer-api-key";
import TaxPayerApiKeyForm from "./TaxPayerApiKeyForm";

interface TaxPayerApiKeyEditModalProps {
  show: boolean;
  apiKey?: TaxPayerApiKey;
  onCancel: () => void | Promise<void>;
  onSuccess: (_?: TaxPayerApiKey) => void | Promise<void>;
}

const TaxPayerApiKeyEditModal: React.FC<TaxPayerApiKeyEditModalProps> = ({
  show,
  apiKey,
  onCancel,
  onSuccess,
}) => {
  return (
    <CModal show={show} onClose={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Editar API Key</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          {show && apiKey ? (
            <TaxPayerApiKeyForm
              apiKey={apiKey}
              onCancel={onCancel}
              onSuccess={onSuccess}
            />
          ) : (
            <></>
          )}
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default TaxPayerApiKeyEditModal;
